<template>
    <div v-if="message">
        <div class="my-3" :class="'alert alert-' + alertType">{{ message }}</div>
    </div>
</template>

<script>
export default {
    props: {
        message: String,
        alertType: {
            type: String,
            default() {
                return 'success';
            }
        },
    }
}
</script>
